import { Link } from '@tanstack/react-router';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import { LockOpenIcon } from 'lucide-react';

type Props = {
  children?: React.ReactNode;
  className?: string;
  iconClassName?: string;
  variant?: 'default' | 'small';
};

const upgradeLinkVariants = cva(
  'group gap-1.5 inline-flex items-center rounded-md pl-3 pr-4 py-2 transition-colors border border-orange-700 dark:border-orange-300 hover:border-orange-800 text-orange-800 dark:text-orange-200 hover:brightness-115',
  {
    variants: {
      variant: {
        default: '',
        small: 'px-2! py-1.5! text-xs',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export function UpgradeLink({ children = 'Upgrade', className, iconClassName, variant }: Props) {
  return (
    <Link to="/pricing" className={clsx(upgradeLinkVariants({ variant }), className)}>
      <LockOpenIcon
        className={clsx('transition-transform group-hover:scale-110', iconClassName)}
        size={16}
      />
      <span className="transition-transform font-medium group-hover:translate-x-0.5">
        {children}
      </span>
    </Link>
  );
}
